import { z } from 'zod';
import {
    WidgetType,
    ZodBaseWidgetConfiguration,
    ZodGenericWidgetConfigurationDetails,
} from '../types';
import {
    zMarshalToBoolean,
    zMarshalToNumber,
    zMarshalToStrictInt,
} from '../../ReachApi/Marshallers';

enum BaseLayers {
    Standard = 'standard',
    Satellite = 'satellite',
    Topographic = 'topographic',
    Ocean = 'ocean',
    DarkCanvas = 'darkcanvas',
}

export const ZodWeatherRadarWidgetConfigurationDetails =
    ZodGenericWidgetConfigurationDetails.extend({
        base_layer: z.nativeEnum(BaseLayers),
        zoom: z.union([z.string(), z.number()]).transform(zMarshalToStrictInt),
        county: z.unknown().transform(zMarshalToBoolean),
        state: z.unknown().transform(zMarshalToBoolean),
        artcc: z.unknown().transform(zMarshalToBoolean),
        cwa: z.unknown().transform(zMarshalToBoolean),
        rfc: z.unknown().transform(zMarshalToBoolean),
        latitude: z.union([z.string(), z.number()]).transform(zMarshalToNumber),
        longitude: z.union([z.string(), z.number()]).transform(zMarshalToNumber),
        location: z.string().nonempty(),
    });

export const ZodWeatherRadarWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.WEATHER_RADAR),
    config: ZodWeatherRadarWidgetConfigurationDetails,
});

export type WeatherRadarWidgetConfigurationDetails = z.infer<
    typeof ZodWeatherRadarWidgetConfigurationDetails
>;

export type WeatherRadarWidgetConfiguration = z.infer<typeof ZodWeatherRadarWidgetConfiguration>;

const coordinatesSchema = z.number().array().length(2);

const NwsWeatherRadarSettingsSchema = z.object({
    agenda: z.object({
        id: z.literal('weather'),
        center: coordinatesSchema,
        location: coordinatesSchema,
        zoom: z.number().min(1).max(12),
    }),
    animating: z.boolean().default(true),
    base: z.nativeEnum(BaseLayers),
    artcc: z.boolean(),
    county: z.boolean(),
    cwa: z.boolean(),
    rfc: z.boolean(),
    state: z.boolean(),
    menu: z.boolean().default(false),
    shortFusedOnly: z.boolean().default(false),
    opacity: z.object({
        alerts: z.number().default(0.8),
        local: z.number().default(0.6),
        localStation: z.number().default(0.8),
        national: z.number().default(0.6),
    }),
});

export type NwsRadarSettings = z.infer<typeof NwsWeatherRadarSettingsSchema>;
